import request from '../../shared/lib/request'

function fetchGroup(page) {
    return request({
        url: `/municipal-report/group`,
        method: 'POST',
        data: {
            page,
        }
    });
}

const MunicipalReportService = {
    fetchGroup
}

export default MunicipalReportService;
